<div class="content-wrapper">
    <div class="content-body">
        <section id="leads">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'COUNSELLOR_ASSIGN'">
                            <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                            <span>Assign Counsellor - {{selectedLead?.name}}</span>
                        </h4>
                        <h4 class="modal-title font-weight-bold" *ngIf="modalType === 'STATUS'">
                            <i class="fas fa-flag-checkered cursor-pointer mr-2"></i>
                            <span>Update Status - {{selectedLead?.name}}</span>
                        </h4>
                        <i class="fas fa-times-circle pull-right text-danger cross-icon cursor-pointer"
                           (click)="this.modalService.dismissAll('')"></i>
                    </div>
                    <div class="modal-body">
                        <div class="row" *ngIf="modalType === 'COUNSELLOR_ASSIGN'">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>
                            <form class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12 form mt-2 shadow-none"
                                  novalidate [formGroup]="assignCounsellorForm">
                                <div class="form-group">
                                    <label for="assigned_to">Assign Counsellor</label>
                                    <select class="form-control" id="assigned_to" formControlName="assigned_to">
                                        <option value="">Select Counsellor</option>
                                        <option [value]="counsellor?.user?.id"
                                                *ngFor="let counsellor of counsellors">{{counsellor?.user?.name}}</option>
                                    </select>
                                    <small *ngIf="submitted && assignCounsellorForm.get('assigned_to').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </form>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>
                        </div>
                        <div class="row" *ngIf="modalType === 'STATUS'">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>
                            <form class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-12 form mt-2 shadow-none"
                                  novalidate [formGroup]="statusForm">
                                <div class="form-group">
                                    <label for="status">Status</label>
                                    <select class="form-control" id="status" formControlName="status">
                                        <option value="">Select Status</option>
                                        <option [value]="status" *ngFor="let status of statuses">{{status}}</option>
                                    </select>
                                    <small *ngIf="submitted && statusForm.get('status').hasError('required')"
                                           class="text-danger">
                                        Field is required.
                                    </small>
                                </div>
                            </form>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success btn-raised" type="button"
                                *ngIf="modalType === 'COUNSELLOR_ASSIGN'"
                                [disabled]="submitting"
                                (click)="assignCounsellor()">
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Submit
                        </button>
                        <button class="btn btn-success btn-raised" type="button"
                                *ngIf="modalType === 'STATUS'"
                                [disabled]="submitting"
                                (click)="changeStatus()">
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Submit
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <h2 class="mt-5px">Ask Expert Professional</h2>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <button class="btn btn-primary pull-right color-white users-btn"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name"
                                           placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="contact"
                                           placeholder="Contact">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="email"
                                           placeholder="Email">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row d-none d-md-block overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No.</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Name</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Contact</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">OTP</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Email</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Course</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">University</h6></th>
                                            <th class="text-center"
                                                *ngIf="user && (['SUPER_ADMIN', 'ADMIN'].indexOf(user['user_type']) !== -1)">
                                                <h6 class="mt-1 mb-1 font-weight-bold">Counsellor</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Status</h6></th>
                                            <th class="text-center min-width-250px"><h6 class="mt-1 mb-1 font-weight-bold">Date</h6></th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Details</h6></th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="leads && leads.length > 0; else noDataToShowWeb">
                                        <tr *ngFor="let lead of leads; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}.</h6>
                                            </td>
                                            <td class="text-center min-width-250px max-width-250px">
                                                <h6 class="mt-1">{{lead?.name}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6 class="mt-1">{{lead?.contact}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <span class="badge badge-success" *ngIf="lead?.otp_verified === true">Verified</span>
                                                <span class="badge badge-danger" *ngIf="lead?.otp_verified === false">Not Verified</span>
                                                <span *ngIf="lead?.otp_verified !== true && lead?.otp_verified !== false">-</span>
                                            </td>
                                            <td class="text-center">
                                                <h6 class="mt-1">{{lead?.email}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6 class="mt-1">{{lead?.course?.course || lead?.course_name}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <h6 class="mt-1">{{lead?.university?.name || '-'}}</h6>
                                            </td>
                                            <td class="text-center max-width-250px"
                                                *ngIf="user && (['SUPER_ADMIN', 'ADMIN'].indexOf(user['user_type']) !== -1)">
                                                <span class="badge badge-primary cursor-pointer"
                                                      (click)="viewCounsellorsModal(content, lead)">
                                                    {{lead?.assigned?.name || 'Unassigned'}}
                                                </span>
                                            </td>
                                            <td class="text-center">
                                                <span class="badge cursor-pointer"
                                                      (click)="changeStatusModal(content, lead)"
                                                      [ngClass]="{
                                                        'badge-secondary': lead['status'] === 'NEW',
                                                        'badge-info': lead['status'] === 'ASSIGNED',
                                                        'badge-warning': (lead['status'] === 'CONTACTED' || lead['status'] === 'FOLLOW_UP'),
                                                        'badge-success': lead['status'] === 'CONVERTED',
                                                        'badge-danger': lead['status'] === 'CLOSED'
                                                      }">
                                                    {{lead['status']}}
                                                </span>
                                            </td>
                                            <td class="text-center min-width-250px">
                                                <h6 class="mt-1">{{lead?.created_at | date}}</h6>
                                            </td>
                                            <td class="text-center">
                                                <i aria-hidden="true" class="fas fa-eye f_20 text-success cursor-pointer"
                                                   title="View Details" (click)="viewDetail(lead)"></i>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="11" class="text-center"><h6>No data to show</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 d-block d-md-none"
                 *ngIf="leads && leads.length > 0; else noDataToShowMobile">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card" *ngFor="let lead of leads; let i = index">
                        <div class="card-header bottom-shadow-light pb-18px">
                            <div class="row width-100-per">
                                <div class="col-10">
                                    <h4 class="card-title text-uppercase card-ellipsis">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}. {{lead?.name}}</h4>
                                </div>
                                <div class="col-2">
                                    <i class="fas fa-eye f_18 text-success cursor-pointer" (click)="viewDetail(lead)"></i>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row p-2">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Email - <h6 class="mt-1">{{lead?.email}}</h6>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Contact - <h6 class="mt-1">{{lead?.contact}}</h6>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    OTP - <h6 class="mt-1">{{lead?.otp_verified === true ? 'Verified' : (lead?.otp_verified === false ? 'Not Verified' : '-')}}</h6>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Course - <h6 class="mt-1">{{lead?.course?.course || lead?.course_name}}</h6>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Assigned To - <h6 class="mt-1">{{lead?.assigned?.name || 'Unassigned'}}</h6>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Status - <h6 class="mt-1">{{lead?.status}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShowMobile>
                <div class="row mt-3 d-block d-md-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card text-center">
                            <h5 class="p-5">No data to show</h5>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination (pageChange)="onPageChange($event)"
                                [(page)]="pagination.page"
                                [boundaryLinks]="true"
                                [collectionSize]="pagination.total"
                                [maxSize]="5"
                                [pageSize]="pagination.perpage">
                </ngb-pagination>
            </div>
        </section>
    </div>
</div>
